import svg from './row-svg/retour.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function RetourIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default RetourIcon;
